import { render, staticRenderFns } from "./SkillAssignRecord.vue?vue&type=template&id=b45937e6"
import script from "./SkillAssignRecord.vue?vue&type=script&lang=js"
export * from "./SkillAssignRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports